module.exports = __webpack_public_path__ + "static/safari-pinned-tab-62ac2485f605dc47263bcc3f42d863a9.svg";